import * as React from 'react'
import * as Immutable from 'immutable'
import * as i18next from 'i18next'
import { any, Updater, async, IOWidget, fromJSX } from 'widgets-for-react'
import {
  FormData,
  FormState,
  DependenciesState,
  FieldId,
  DependencyResult,
  FieldData,
  DependencyId,
  IsMet
} from './types'
import { initializeIcons } from '@uifabric/icons'
import { Fabric } from 'office-ui-fabric-react/lib/Fabric'
import { form_renderer } from './renderers'
import { get_dependency_result } from './utils'
import { AsyncMonitor } from './async_monitor'
import { loader } from '../public_site/templates/loader.mod'

initializeIcons()

export const Form: IOWidget<FormState, Updater<FormState>> = (s0) => {
  let dependencies_async_list = Immutable.List<{
    dep_res: { kind: 'async'; value: AsyncMonitor<IsMet> }
    dep_id: DependencyId
    field_id: FieldId
  }>()
  s0.dependencies_state.forEach((field_id__dep_res, dep_id) => {
    field_id__dep_res.forEach((dep_res, field_id) => {
      if (dep_res.kind == 'async') dependencies_async_list = dependencies_async_list.push({ dep_id, field_id, dep_res })
    })
  })
  return any(
    //we load the async dependencies
    dependencies_async_list
      .map((dep_elem, index) => {
        return dep_elem.dep_res.value.Widget.map<Updater<FormState>>((a) => (s) => {
          let s1 = s
          let a1 = a
          let field_id__dep_res = s.dependencies_state.get(dep_elem.dep_id).set(dep_elem.field_id, {
            kind: 'async',
            value: a1
          })
          return { ...s1, dependencies_state: s1.dependencies_state.set(dep_elem.dep_id, field_id__dep_res) }
        })
      })
      .toArray()
      .concat([
        //we load the form
        async(s0.form_data).map<Updater<FormState>>((a) => (state) => {
          let a1 = a(state.form_data)
          let new_state = { ...state, form_data: a1 }
          if (new_state.form_data.kind == 'loaded') {
            let all_fields: Immutable.Map<FieldId, FieldData> = Immutable.Map<FieldId, FieldData>()
            new_state.form_data.value.steps.forEach((s) => {
              s.fields.forEach((f) => {
                all_fields = all_fields.set(f.Id, f)
              })
            })
            let dependenciesState: DependenciesState = Immutable.Map()
            new_state.form_data.value.steps.forEach((s) => {
              s.dependencies.forEach((d) => {
                let dependent_fields = Immutable.Map<FieldId, DependencyResult>()
                d.dependent_fields.forEach((f) => {
                  if (all_fields.has(f.FieldId)) {
                    let field_dep_state = dependent_fields.get(f.FieldId)
                    let dependency_result = get_dependency_result(
                      f.FieldId,
                      all_fields.get(f.FieldId).user_input,
                      d.dependency,
                      field_dep_state && field_dep_state.kind == 'async' ? field_dep_state.value : undefined
                    )
                    if (dependency_result.kind == 'simple' && dependency_result.value == false) {
                      dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
                    } else {
                      if (dependency_result.kind == 'async') {
                        if (
                          dependency_result.value.Result.kind == 'loaded' &&
                          dependency_result.value.Result.value == false
                        )
                          dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
                        else {
                          if (dependency_result.value.Result.kind != 'unloaded') {
                            dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
                          }
                        }
                      }
                    }
                  }
                })
                dependenciesState = dependenciesState.set(d.dependency.Id, dependent_fields)
              })
            })
            new_state.dependencies_state = dependenciesState
          }
          return new_state
        }),
        async(s0.form_submission_logic, undefined, {
          key: 'submission form async',
          connectionError: fromJSX(() => <p className='message message--error'>Probleem met verbinden</p>),
          loading: (state) =>
            fromJSX(() => <p className='message'>{i18next.t("ContactForm:Texts:SendingFormText")}</p>),
          unauthorizedError: fromJSX(() => <p className='message message--error'>Geen toegang</p>),
          otherError: fromJSX(() => <p className='message message--error'>Er is iets fout gegaan</p>),
          unloaded: null
        }).map<Updater<FormState>>((a) => (s) => {
          const a1 = a(s.form_submission_logic)
          if (s.form_submission_logic.kind === 'loading' && a1.kind === 'loaded') {
            // let s1 : FormState =  undefined
            // if(s.alternative_get_api){
            //   s1 = s.alternative_get_api([], s.form_data.kind === 'loaded' ? s.form_data.value.form.Id.toString() : '')

            // }
            // else{

            //   s1 = getFormState([], s.form_data.kind === 'loaded' ? s.form_data.value.form.Id.toString() : '')
            // }
            return {
              ...s,
              form_submission_logic: a1,
              context: s.context
            }
          }
          return { ...s, form_submission_logic: a1 }
        }),

        fromJSX((setState) => {
            if (s0.form_data.kind != 'loaded') return loader.run(() => {})
            return form_renderer(
              s0.form_data.value,
              s0,
              (new_form_submission_logic) =>
                setState((s) => ({
                  ...s,
                  form_submission_logic: new_form_submission_logic
                })),
              (new_form, new_dependencies) =>
                setState((s) => {
                  if (s.form_data.kind != 'loaded') return s
                  if (s.form_started == false) {
                    window.dataLayer.push({
                      event: `event.${sitename}`,
                      category: s.form_data.value.form.title,
                      action: 'Start form',
                      label: window.location.pathname
                    })
                  }
                  return {
                    ...s,
                    form_data: { ...s.form_data, value: new_form },
                    dependencies_state: new_dependencies,
                    form_started: true
                  }
                }),
              (token) => {
                setState((state) => {
                  return { ...state, recaptcha_token: token }
                })
              }
            )
          }
        )
      ])
  ).wrapHTML((jsx) => <Fabric className="paragraph paragraph--form">{jsx}</Fabric>)
}
